import axios, { AxiosResponse } from 'axios';
import { get } from 'lodash';
import { CreateOrganisationAssignmentRequestDto, OrganisationAssignmentDto, OrganisationAssignmentDtoQueryResultDto, OrganisationAssignmentsApi, QueryAndCountDto, QueryAndSortDto } from 'models/dtoTypes';
import { getApiConfiguration } from 'services';

export const getOrganisationAssignmentApi = async () => new OrganisationAssignmentsApi(await getApiConfiguration());

const handleError = (e: unknown) => {
  if (axios.isAxiosError(e) && e.response) {
    console.log(e.response?.data);
    const errorMessage = get(e.response?.data, 'message') || 'Something went wrong';
    throw new Error(errorMessage);
  } else {
    // native error
    throw e;
  }
};

type IFunc<T, K> = (params: T) => Promise<K>;

const execute = async <T,K>(fn: IFunc<T, AxiosResponse<K>>, params: T) => {
  try {
    const response = await fn(params);
    return response.data;
  } catch (e) {
    return handleError(e);
  }
};

export const CreateOrganisationAssignment = async (createDto: CreateOrganisationAssignmentRequestDto): Promise<OrganisationAssignmentDto> => {
  const client = await getOrganisationAssignmentApi();
  return execute((params) => client.createOrganisationAssignment(params), createDto);
};

export const GetAllOrganisationAssignments = async (queryAndCountDto: QueryAndCountDto): Promise<OrganisationAssignmentDtoQueryResultDto> => {
  const client = await getOrganisationAssignmentApi();
  const response = await client.getAllOrganisationAssignments(queryAndCountDto);
  return response.data;
};

export const GetAllOrganisationAssignmentsAssignedToMe = async (queryAndSortDto: QueryAndSortDto): Promise<OrganisationAssignmentDto[]> => {
  const client = await getOrganisationAssignmentApi();
  const response = await client.getAllOrganisationAssignmentsAssignedToMe(queryAndSortDto);
  return response.data;
};

export const GetOrganisationAssignment = async (id: string): Promise<OrganisationAssignmentDto> => {
  const client = await getOrganisationAssignmentApi();
  const response = await client.getOrganisationAssignment(id);
  return response.data;
};


export const AcceptOrganisationAssignment = async (id: string): Promise<OrganisationAssignmentDto> => {
  const client = await getOrganisationAssignmentApi();
  const response = await client.acceptOrganisationAssignment(id);
  return response.data;
};

export const DeleteOrganisationAssignment = async (id: string): Promise<void> => {
  const client = await getOrganisationAssignmentApi();
  await client.deleteOrganisationAssignment(id);
};

